import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { BaseComponent } from '../../components/BaseComponent';

import { fetchAllOptions } from '../../modules/Vehicles/actions';
import './style.scss';
import { selectAllOptions } from '../../modules/Vehicles/selectors';

const Container = styled.div``;

/* eslint-disable react/prefer-stateless-function */
class AuthorizedComp extends BaseComponent {
  componentDidMount() {
    this.props.fetch();
  }

  render() {
    if (!this.props.allOptions?.length) return null;
    return this.props.children;
  }
}

AuthorizedComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    allOptions: selectAllOptions(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetch() {
      dispatch(fetchAllOptions());
    },
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const Authorized = compose(
  withConnect,
  withRouter,
)(AuthorizedComp);
